import PropTypes from 'prop-types';
import React from 'react';

const SelectionRadio = ({ isSelected }) =>
  isSelected ? (
    <div className="w-4 h-4 border border-primary rounded-full flex items-center justify-center">
      <div className="w-2 h-2 bg-primary rounded-full" />
    </div>
  ) : (
    <div className="w-4 h-4 border border-grey-dark rounded-full" />
  );

SelectionRadio.propTypes = {
  isSelected: PropTypes.bool,
};

export default SelectionRadio;
